import { communityCopy } from '@/nominations/communityCopy'

type RoomSectionProps = {
  titleId: string
}

export const RoomSection = ({ titleId }: RoomSectionProps) => (
  <section className="nom-room" aria-labelledby={titleId}>
    <div className="x-wrap">
      <div className="nom-room-head">
        <div className="nom-room-title">
          <p className="x-eyebrow x-eyebrow--ink">{communityCopy.roomEyebrow}</p>
          <h2 id={titleId} className="x-h2">
            {communityCopy.roomTitle}
          </h2>
        </div>
        <div className="nom-room-body">
          {communityCopy.roomBody.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
      <ol className="nom-principles" aria-label="How the room works">
        {communityCopy.principles.map((principle) => (
          <li key={principle.number} className="nom-principle">
            <span className="nom-principle-number" aria-hidden>
              {principle.number}
            </span>
            <h3>{principle.title}</h3>
            <p>{principle.body}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
)
